





















































































































































































































































import { Component, Vue } from "vue-property-decorator";
import { mapGetters, mapActions } from "vuex";

@Component({
	computed: {
		...mapGetters("users", ["userInfo"]),
		...mapGetters("profile", [
			"userProfile",
			"socialLinks",
			"skills",
			"experiance",
			"education"
		])
	},
	methods: {
		...mapActions("users", ["uploadAvatar"]),
		...mapActions("profile", [
			"getUserProfile",
			"deleteExperiance",
			"deleteEducation"
		])
	}
})
export default class Profile extends Vue {
	userInfo!: any;
	userProfile!: any;
	socialLinks!: any;
	skills!: any;
	experiance!: any;
	education!: any;
	profileEditDialog = false;
	getUserProfile!: Function;
	deleteExperiance!: Function;
	deleteEducation!: Function;
	uploadAvatar!: Function;

	loadingExpDel = false;
	loadingEduDel = false;

	created() {
		console.log("fetch users profile data please please!!!");
		console.log("thisi s the user id: ", this.userInfo.id, this.userInfo);
		this.getUserProfile(this.userInfo.id);
	}

	uploadProfileAvatar() {
		const form = document.getElementById("profile-pic") as HTMLFormElement;
		const formData = new FormData(form);
		this.uploadAvatar(formData);
		this.getUserProfile(this.userInfo.id);
		this.profileEditDialog = false;
	}

	get socialLinksDispaly() {
		const links = [];
		if (this.socialLinks) {
			const {
				youtube,
				facebook,
				twitter,
				linkedin,
				instagram
			} = this.socialLinks;
			if (youtube) links.push({ link: youtube, icon: "mdi-youtube" });
			if (facebook) links.push({ link: facebook, icon: "mdi-facebook" });
			if (twitter) links.push({ link: twitter, icon: "mdi-twitter" });
			if (linkedin) links.push({ link: linkedin, icon: "mdi-linkedin" });
			if (instagram) links.push({ link: instagram, icon: "mdi-instagram" });
			return links;
		}
		return [];
	}

	deleteExperianceField(id: string) {
		this.loadingExpDel = true;
		this.deleteExperiance(id)
			.then(() => {
				this.$store.dispatch(
					"snackbar",
					"Experiance Field Delete Successfully"
				);
				this.loadingExpDel = false;
			})
			.catch((err: any) => {
				this.loadingExpDel = false;
				console.log(err);
			});
	}

	deleteEducationField(id: string) {
		this.loadingEduDel = true;
		this.deleteEducation(id)
			.then(() => {
				this.$store.dispatch("snackbar", "Education Field Delete Successfully");
				this.loadingEduDel = false;
			})
			.catch((err: any) => {
				this.loadingEduDel = false;
				console.log(err);
			});
	}
}
